import { connect } from 'react-redux';
import { IApplicationState } from 'app/types/types';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ICustomPropertiesHOCProps } from './types';
import { getBoardCustomProperties } from './selectors/getBoardCustomProperties';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';
import { ICustomPropertiesEvents, ICustomPropertiesFields } from '../../components/CustomProperties/types';
import { CustomProperties } from '../../components/CustomProperties/CustomProperties';
import { onOpen } from './events/onOpen';
import { onClickEdit } from './events/onClickEdit';
import { onClickCancel } from './events/onClickCancel';
import { onAdd } from './events/onAdd';
import { onSave } from './events/onSave';
import { onConfirmDelete } from './events/onConfirmDelete';

const mapStateToProps = () => {
    return (
        state: IApplicationState,
        ownProps: ICustomPropertiesHOCProps
    ): ICustomPropertiesFields => {
        const { boardId, sectionType: sectionTypeOwn } = ownProps;
        const sectionType = getSectionType(state, boardId, sectionTypeOwn, 'allowCardCustomProperties');
        return {
            boardId,
            elements: getBoardCustomProperties(state, boardId),
            isEssentialFeature: getIsUserEssentialPlanOnly(state),
            sectionType,
        }
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: ICustomPropertiesHOCProps,
): ICustomPropertiesEvents => {
    return {
        onAdd: (name, type, options) => dispatch(onAdd(boardId, name, type, options)),
        onConfirmDelete: (id) => dispatch(onConfirmDelete(boardId, id)),
        onClickCancel: () => dispatch(onClickCancel()),
        onClickEdit: () => dispatch(onClickEdit()),
        onOpen: () => dispatch(onOpen()),
        onSave: (elements) => dispatch(onSave(boardId, elements)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    }
};

export const CustomPropertiesHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomProperties);

CustomPropertiesHOC.displayName = 'CustomPropertiesHOC';
